/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowConfigurationQueryResponse, GetShowConfigurationPathParams, GetShowConfigurationQueryParams, GetShowConfiguration404 } from "../../models/GetShowConfiguration";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowConfigurationUrl({ uuid }: { uuid: GetShowConfigurationPathParams["uuid"] }) {
  const res = { method: 'GET', url: `/api/v1/configurations/${uuid}` as const }  
  return res
}

/**
 * {@link /api/v1/configurations/:uuid}
 */
export async function getShowConfiguration({ uuid, params }: { uuid: GetShowConfigurationPathParams["uuid"]; params: GetShowConfigurationQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowConfigurationQueryResponse, ResponseErrorConfig<GetShowConfiguration404>, unknown>({ method : "GET", url : getGetShowConfigurationUrl({ uuid }).url.toString(), params, ... requestConfig })  
  return res.data
}